import script from "./map.vue?vue&type=script&setup=true&lang=js"
export * from "./map.vue?vue&type=script&setup=true&lang=js"

import "./map.vue?vue&type=style&index=0&id=4812b6b6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4812b6b6"]])

export default __exports__